import React, { useEffect, useRef, useState } from 'react'
import filter from '../assets/images/filetype.svg'
import success from '../assets/images/success.svg'
import cancel from '../assets/images/cancel.svg'
import * as XLSX from 'xlsx'

const allowedExtensions = ["csv", "xlsx", "xls"];
export const DocumentModal = ({ onRequestClose }) => {
    // Use useEffect to add an event listener to the document
    useEffect(() => {
        function onKeyDown(event) {
            if (event.keyCode === 27) {
                // Close the modal when the Escape key is pressed
                onRequestClose();
            }
        }
        // Prevent scolling
        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onKeyDown);
        // Clear things up when unmounting this component
        return () => {
            document.body.style.overflow = "visible";
            document.removeEventListener("keydown", onKeyDown);
        };
    });

    const [displayModal, setDisplayModal] = useState("upload")

    const inputElement = useRef();
    const uploadButton = useRef();
    const [file, setFile] = useState("");
    const [data, setData] = useState([]);
    const checkFileName = (name) => {
        return allowedExtensions.includes(name.split(".").pop().toLowerCase())
    }
    const cancelUpload = async (e) => {
        setDisplayModal("cancel")
        // onRequestClose()
    }
    const confirmCancel = async (e) => {
        setDisplayModal("upload")
        // onRequestClose()
    }
    const handleFileChange2 = async (e) => {
        const fileName = e.target.files[0]
        console.log(fileName);
        if (!checkFileName(fileName.name)) {
            alert("not type")
            return 0
        }
        setFile(fileName.name);
        const data = await fileName.arrayBuffer();
        const wb = XLSX.read(data);
        const sheet = wb.SheetNames[0];
        console.log("WB = ", wb)
        console.log("Sheet = ", wb.Sheets[sheet])
        console.log(XLSX.utils.sheet_to_json(wb.Sheets[sheet]));
        setData(XLSX.utils.sheet_to_json(wb.Sheets[sheet]));


        console.log(uploadButton.current.disabled)
        uploadButton.current.disabled = false;
        console.log(uploadButton.current.disabled)
    }
    const changeFile = () => {
        inputElement.current.value = "";
    }
    function documentUploaded(value) {
        console.log("Button = ", uploadButton.current)
        setDisplayModal("success")
    }
    return (
        <>
            <div className="modal__backdrop">
                {
                    displayModal === "upload" ?
                        <>
                            <div className="modal__container">
                                <div className='modal__heading'>
                                    Document Upload
                                </div>
                                <div className='modal__file'>File Name</div>
                                <div className='modal__document'>
                                    <div className='modal__file-icon'>
                                        <img src={filter} alt="file" />
                                    </div>
                                    <div className='modal__document-inner'>
                                        <div className='modal__document-data'>
                                            <div className='modal__file-type'>File</div>
                                            <div className='modal__file-name'>
                                                <input id="fileupload" type="File" accept='application/vnd.ms-excel, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                    ref={inputElement} onChange={(e) => handleFileChange2(e)} name="fileupload" multiple={false} style={{ display: "block" }} />
                                            </div>
                                        </div>
                                        <button className='modal__button-change' onClick={() => { changeFile() }} type="button">Change</button>
                                    </div>
                                </div>
                                <div className='modal__button'>
                                    <button className='modal__button-cancel' style={{ backgroundColor: "transparent", color: "#6D6D6D" }} type="button" onClick={() => { cancelUpload() }}>Cancel</button>
                                    <button className='modal__button-cancel' style={{ backgroundColor: "#82C1A7", color: "#FFFFFF" }} type="button" onClick={() => { documentUploaded() }} ref={uploadButton}>Upload</button>
                                </div>
                            </div>
                        </>
                        :
                        displayModal === "success" ?
                            <>
                                <div className="modal__container" style={{ width: "400px" }}>
                                    <div className='modal__success-container'>
                                        <img src={success} alt="success" />
                                        <span>Success</span>
                                        <p>Document Uploaded Successfully</p>
                                        <button id="success" onClick={onRequestClose}>Done</button>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="modal__container" style={{ width: "400px" }}>
                                    <div className='modal__success-container'>
                                        <img src={cancel} alt="cancel" />
                                        <span>Are You Sure?</span>
                                        <p style={{ fontFamily: 'Open Sans' }}>Do you really want to cancel the upload?</p>
                                        <div className='modal__cancel-button'>
                                            <button id="confirm" style={{ backgroundColor: "#BDBDBD" }} onClick={onRequestClose}>Confirm</button>
                                            <button id="cancel" style={{ backgroundColor: "#C86140" }} onClick={() => { confirmCancel() }}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </>
                }
            </div>
        </>
    );
};